import { FlagListData } from '@modules/HappinessModule/interfaces/FlagListData';
import { createAction } from '@reduxjs/toolkit';
import { AsyncData } from 'shared/interfaces/asyncData';

export const getUsersFlagsData = createAction<string>('usersFlags/getUsersFlagsData');
export const setUsersFlagsData = createAction<AsyncData<FlagListData[]>>('usersFlags/setUsersFlagsData');
